import Schedule from "../../../../src/components/Schedule";
import Speakers from "../../../../src/components/Speakers";
import React from 'react';
export default {
  Schedule,
  Speakers,
  React
};